/**
 * Returns the message text for the QuotaZeroCTA banner based on the variant type.
 *
 * @param {string} type - One of: "trial_used_up", "upgrade_only", "packs_only", "upgrade_and_packs"
 * @param {string} consumable - "credits" or "AI words"
 * @param {object} options
 * @param {boolean} options.showBetterPlanMessage - Whether user is on a legacy plan being offered v3
 * @param {string} options.planTitle - Current plan title (e.g., "Pro", "Hobby")
 * @param {number} options.totalQuota - Total remaining quota
 * @param {string|null} options.nonZeroMessage - Custom message for non-zero quota
 * @returns {{ text: string, bold: string|null }|null} Message object with text and optional bold prefix, or null
 */
export function getQuotaZeroMessage(type, consumable, options = {}) {
  const { showBetterPlanMessage = false, planTitle = "", totalQuota = 0, nonZeroMessage = null } = options;

  switch (type) {
    case "trial_used_up":
      return {
        bold: null,
        text: `You've used all your ${consumable} for your free trial. Subscribe to keep using Sudowrite.`,
      };

    case "upgrade_only":
      if (showBetterPlanMessage) {
        return {
          bold: "Look at you go!",
          text: `You used up all the ${consumable} on your current plan. Good news \u2192 Our new ${planTitle} plan has three times as many ${consumable}!`,
        };
      }
      return {
        bold: "Look at you go!",
        text: `You used up all the ${consumable} for your current plan. Upgrade your plan to keep using Sudowrite.`,
      };

    case "packs_only":
      return {
        bold: null,
        text: `Buy a pack of ${consumable} to keep access to Sudowrite's features.`,
      };

    case "upgrade_and_packs":
      if (totalQuota <= 0) {
        return {
          bold: "Look at you go!",
          text: `You used up all the ${consumable} for your current plan. Upgrade your plan or buy a pack of ${consumable} to keep using Sudowrite.`,
        };
      }
      if (nonZeroMessage) {
        return { bold: null, text: nonZeroMessage };
      }
      return null;

    default:
      return null;
  }
}
